export default "/images/add-space-type-icon.svg";